import styled from 'styled-components';

export const StaticHeader = styled.div<{ $isTranslated: boolean }>`
  background: linear-gradient(to right, rgb(15 17 19 / 70%), rgb(25 21 64 / 70%));
  backdrop-filter: blur(15px);
  padding: 20px;
  z-index: 1000;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  transition: box-shadow 0.2s ease;
  box-shadow: ${props => props.$isTranslated ? '0 6px 8px rgb(0 0 0 / 67%)' : 'none'};
`;

export const TopContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  margin-bottom: 20px;
  width: 100%;
  position: relative;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: fit-content;
  position: absolute;
  left: 0;

  @media (max-width: 768px) {
    position: relative;
    width: 100%;
    justify-content: space-between;
  }
`;

export const SearchContainer = styled.div<{ $isVisible: boolean }>`
  position: relative;
  width: 100%;
  max-width: 350px;
  margin: 0 auto;
  display: block;

  @media (max-width: 768px) {
    width: 100%;
    max-width: 100%;
    margin: 0;
    display: ${props => props.$isVisible ? 'block' : 'none'};
  }
`;

export const TitleContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
  margin-top: 0;
  margin-bottom: 20px;
  width: 100%;
`;

export const LogoTitle = styled.h2`
  margin: 0;
  color: white;
  font-size: 24px;
  font-weight: bold;
`;

export const LogoCircle = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  
  img {
    width: 24px;
    height: 24px;
    object-fit: contain;
  }
`;

export const SearchInput = styled.input`
  width: 100%;
  box-sizing: border-box;
  padding: 8px 16px;
  border-radius: 20px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(255, 255, 255, 0.1);
  color: white;
  font-size: 16px;
  
  &::placeholder {
    color: rgba(255, 255, 255, 0.5);
  }
  
  &:focus {
    outline: none;
    border-color: rgba(255, 255, 255, 0.2);
  }

  &::-webkit-search-cancel-button {
    -webkit-appearance: none;
    appearance: none;
  }
`;

export const ClearButton = styled.button`
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  color: rgba(255, 255, 255, 0.5);
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  
  &:hover {
    color: rgba(255, 255, 255, 0.8);
  }
`;

export const SelectPill = styled.button<{ $isSelected?: boolean; $isDisabled?: boolean }>`
  padding: 8px 16px;
  border-radius: 20px;
  background: ${props => props.$isSelected ? 'white' : 'rgba(255, 255, 255, 0.1)'};
  border: 1px solid ${props => props.$isSelected ? 'white' : 'rgba(255, 255, 255, 0.1)'};
  color: ${props => {
    if (props.$isDisabled) return 'rgba(255, 255, 255, 0.3)';
    return props.$isSelected ? '#191540' : 'white';
  }};
  cursor: ${props => props.$isDisabled ? 'not-allowed' : 'pointer'};
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 16px;
  opacity: ${props => props.$isDisabled ? 0.5 : 1};
  
  &:hover {
    background: ${props => {
      if (props.$isDisabled) return 'rgba(255, 255, 255, 0.1)';
      return props.$isSelected ? 'white' : 'rgba(255, 255, 255, 0.2)';
    }};
  }
`;

export const SelectorsContainer = styled.div`
  display: flex;
  gap: 12px;
`;

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.9);
  z-index: 10000;
  display: flex;
  justify-content: center;
`;

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding-bottom: 80px;
  height: 100%;
  width: 100%;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 40px;
    background: linear-gradient(to top, transparent, black);
    pointer-events: none;
    z-index: 1;
  }

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 150px;
    background: linear-gradient(to bottom, transparent 0%, black 90%);
    pointer-events: none;
  }
`;

export const OptionsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 120px 20px 170px 20px;
  overflow-y: auto;
  overscroll-behavior: contain;
  -webkit-overflow-scrolling: touch;
  align-items: center;


  /* Hide scrollbar for Chrome, Safari and Opera */
  &::-webkit-scrollbar {
    display: none;
  }
  
  /* Hide scrollbar for IE, Edge and Firefox */
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */
`;

export const Option = styled.button<{ $isSelected: boolean; $isDisabled?: boolean }>`
  padding: 16px;
  border: none;
  background: ${props => props.$isSelected ? 'white' : 'transparent'};
  color: ${props => {
    if (props.$isDisabled) return 'rgba(255, 255, 255, 0.3)';
    return props.$isSelected ? '#191540' : 'white';
  }};
  text-align: center;
  cursor: ${props => props.$isDisabled ? 'not-allowed' : 'pointer'};
  border-radius: 50px;
  font-size: 1.5rem;
  width: 100%;
  max-width: 400px;
  font-family: 'Poppins', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen';
  opacity: ${props => props.$isDisabled ? 0.5 : 1};
  
  &:hover {
    background: ${props => {
      if (props.$isDisabled) return 'transparent';
      return props.$isSelected ? 'white' : 'rgba(255, 255, 255, 0.1)';
    }};
  }
`;

export const CloseButton = styled.button`
  background: white;
  border: none;
  color: #191540;
  cursor: pointer;
  width: 64px;
  height: 64px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  bottom: 40px;
  left: 50%;
  transform: translateX(-50%);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  transition: transform 0.2s ease;
  z-index: 1000;

  &:hover {
    transform: translateX(-50%) scale(1.1);
  }

  &:active {
    transform: translateX(-50%) scale(0.95);
  }
`;

export const SearchIconButton = styled.button`
  background: none;
  border: none;
  color: white;
  cursor: pointer;
  padding: 8px;
  margin-left: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  
  &:hover {
    color: rgba(255, 255, 255, 0.8);
  }
`;

export const MobileSearchIcon = styled.button`
  background: none;
  border: none;
  color: white;
  cursor: pointer;
  padding: 8px;
  margin-left: auto;
  display: none;
  align-items: center;
  justify-content: center;
  
  &:hover {
    color: rgba(255, 255, 255, 0.8);
  }

  @media (max-width: 768px) {
    display: flex;
  }
`;